import { toast } from "sonner";

// Copy text without ever throwing — the Clipboard API rejects in non-secure or
// sandboxed contexts, which would otherwise surface a runtime error overlay.
export async function copyText(text, successMsg = "Copied!") {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMsg);
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.focus(); ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      toast.success(successMsg);
    } catch {
      toast.info("Copy not available — please copy manually.");
    }
  }
}
